<script setup>const route=useRoute();defineProps(['profile']);</script>
<template><CommunityProfileGroups :user-id="route.params.id"/></template>
